/**
 * nginx caps request bodies at 2MB (devops/nginx.conf, nginx-internal.conf). Each roast is
 * saved in its own request — the original file plus the reviewed profile as JSON — so this
 * ceiling sits below the cap to leave room for that payload and the multipart boundaries.
 *
 * Files above it are refused while they are still in the browser, so the reason is named
 * instead of arriving as an opaque 413 from the proxy.
 */
export const MAX_ARTISAN_FILE_BYTES = 1_500_000;
